import React from "react";
import SectionHeaderTitle from "../../components/ui/SectionHeaderTitle";
import { useLanguage } from "../../context/LanguageContext";
import normalCourse from "../../assets/komet-assets/normalCourse.png";
import IntensiveCourse from "../../assets/komet-assets/IntensiveCourse.png";
import superCourse from "../../assets/komet-assets/superCourse.png";
import flashCourse from "../../assets/komet-assets/flashCourse.png";
import { Link } from "react-router-dom";

const CategoriesSection = () => {
    const { language } = useLanguage();
    const content = {
        SectionHeaderTitle: {
            en: "Bridges Between Cultures",
            de: "Brücken zwischen Kulturen",
            ar: "جسور بين الثقافات",
        },
        SectionDescription: {
            en: "We help you build strong cultural connections with the German community through learning and mastering the language.",
            de: "Wir helfen Ihnen, starke kulturelle Verbindungen mit der deutschen Gemeinschaft aufzubauen, indem Sie die Sprache lernen und meistern.",
            ar: "نساعدك على بناء علاقات ثقافية قوية مع المجتمع الألماني من خلال تعلم اللغة وإتقانها.",
        },
    };
    const mainSubjects = [
        {
            id: 1,
            title: {
                en: "Regular Courses",
                de: "Reguläre Kurse",
                ar: "دورات منتظمة",
            },
            count: "2x / week",
            image: normalCourse,
        },
        {
            id: 2,
            title: {
                en: "Intensive Courses",
                de: "Intensivkurse",
                ar: "دورات مكثفة",
            },
            count: "3x / week",
            image: IntensiveCourse,
        },
        {
            id: 3,
            title: {
                en: "Premium Intensive Courses",
                de: "Premium-Intensivkurse",
                ar: "دورات مكثفة متميزة",
            },
            count: "3x / week",
            image: superCourse,
        },
        {
            id: 4,
            title: {
                en: "Fast-Track Courses",
                de: "Schnellkurse",
                ar: "الدورات السريعة",
            },
            count: "5x / week",
            image: flashCourse,
        },
    ];

    return (
        <section className=" min-h-[50vh] pb-10 px-10 md:px-20 flex flex-col space-y-20 relative overflow-hidden">
            <div
                className={`px-0 md:px-20 text-center ${
                    language === "ar" ? "md:text-right" : "md:text-left"
                }`}
            >
                <SectionHeaderTitle title={content.SectionHeaderTitle[language]} />
                <p className="text-gray-600 w-full md:w-[66%] text-xl md:text-2xl mt-2">
                    {content.SectionDescription[language]}
                </p>
            </div>
            <div className="flex-center-both rtl gap-10 pb-20  flex-wrap mt-10">
                {mainSubjects.map((subject) => (
                    <Link key={subject.id} to={`/subject/${subject.id}`}>
                        <div
                            className="relative bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
                            style={{ width: "300px", height: "300px" }}
                        >
                            <img
                                src={subject.image}
                                alt={subject.title[language]}
                                className="w-full h-full object-cover rounded-xl"
                            />
                            <div className="absolute right-0 left-0 -bottom-10 flex items-center justify-end bg-white/20 backdrop-blur-md p-4 rounded-lg m-4">
                                <div className="flex-center-both text-left gap-2">
                                    <div>
                                        <p className="text-yellow-400 text-stroke-black font-bold text-xl">
                                            {subject.count}
                                        </p>
                                        <h3 className="text-black font-mont font-bold text-lg">
                                            {subject.title[language]}
                                        </h3>
                                    </div>
                                    <div className="h-10 w-1 bg-germanRed-700" />
                                </div>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </section>
    );
};

export default CategoriesSection;
